var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"54a9d64c5eb1244407c1cd5bca6b675f8053f19d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["onoty"]={id:"54a9d64c5eb1244407c1cd5bca6b675f8053f19d"};
      